// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageConfirmCancelling_root__Ryn65","description":"MessageConfirmCancelling_description__wYSy6","button":"MessageConfirmCancelling_button__CH5E8"};